module.exports = __webpack_public_path__ + "static/assets/8631e81b32644527d0d056b213faddc8.svg";